var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rb-modal",
    {
      attrs: { options: _vm.modalOptions },
      on: {
        cancel: function ($event) {
          return _vm.cancel()
        },
        hide: function ($event) {
          _vm.confirmed && _vm.hide()
        },
      },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v(_vm._s(_vm.headerText)),
      ]),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _c("p", [_vm._v(_vm._s(_vm.messageText))]),
        _vm.confirmationText
          ? _c(
              "p",
              [
                _c("rb-checkbox-button", {
                  attrs: { value: _vm.confirmed, "check-box-value": "1" },
                  on: { input: _vm.setConfirmed },
                }),
                _vm._v(" " + _vm._s(_vm.confirmationText) + " "),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }